// Custom Report Permissions
// Only specific users can create and edit custom reports

const ALLOWED_CUSTOM_REPORT_EDITORS = [
  "internal@zotanextech.com"
];

/**
 * Decode JWT token to get payload
 */
const decodeJWT = (token) => {
  try {
    if (!token) return null;
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Error decoding JWT:", e);
    return null;
  }
};

/**
 * Get current user email from JWT token
 */
export const getCurrentUserEmail = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return null;
  const payload = decodeJWT(token);
  return payload?.email || null;
};

/**
 * Check if current user can create and edit custom reports
 */
export const canCreateAndEditCustomReports = () => {
  const email = getCurrentUserEmail();
  if (!email) return false;
  return ALLOWED_CUSTOM_REPORT_EDITORS.includes(email.toLowerCase());
};

export default canCreateAndEditCustomReports;
